import {
  FETCH_ALL_DELIVERY_NOTES,
  FETCH_ALL_DELIVERY_NOTES_SUCCESS,
  FETCH_ALL_DELIVERY_NOTES_FAILURE,
  FETCH_DELIVERY_NOTE_DETAILS,
  FETCH_DELIVERY_NOTE_DETAILS_SUCCESS,
  FETCH_DELIVERY_NOTE_DETAILS_FAILURE,
  CREATE_DELIVERY_NOTE,
  CREATE_DELIVERY_NOTE_SUCCESS,
  CREATE_DELIVERY_NOTE_FAILURE,
  UPDATE_DELIVERY_NOTE,
  UPDATE_DELIVERY_NOTE_SUCCESS,
  UPDATE_DELIVERY_NOTE_FAILURE,
  DELETE_DELIVERY_NOTE,
  DELETE_DELIVERY_NOTE_SUCCESS,
  DELETE_DELIVERY_NOTE_FAILURE,
  SET_DELIVERY_NOTE_IS_EDIT,
} from "./constants";

// Fetch all delivery notes
export const fetchAllDeliveryNotes = (payload) => ({
  type: FETCH_ALL_DELIVERY_NOTES,
  payload,
});

export const fetchAllDeliveryNotesSuccess = (payload) => ({
  type: FETCH_ALL_DELIVERY_NOTES_SUCCESS,
  payload,
});

export const fetchAllDeliveryNotesFailure = (payload) => ({
  type: FETCH_ALL_DELIVERY_NOTES_FAILURE,
  payload,
});

// Fetch delivery note details
export const fetchDeliveryNoteDetails = (payload) => ({
  type: FETCH_DELIVERY_NOTE_DETAILS,
  payload,
});

export const fetchDeliveryNoteDetailsSuccess = (payload) => ({
  type: FETCH_DELIVERY_NOTE_DETAILS_SUCCESS,
  payload,
});

export const fetchDeliveryNoteDetailsFailure = (payload) => ({
  type: FETCH_DELIVERY_NOTE_DETAILS_FAILURE,
  payload,
});

// Create delivery note
export const createDeliveryNote = (payload) => ({
  type: CREATE_DELIVERY_NOTE,
  payload,
});

export const createDeliveryNoteSuccess = (payload) => ({
  type: CREATE_DELIVERY_NOTE_SUCCESS,
  payload,
});

export const createDeliveryNoteFailure = (payload) => ({
  type: CREATE_DELIVERY_NOTE_FAILURE,
  payload,
});

// Update delivery note
export const updateDeliveryNote = (payload) => ({
  type: UPDATE_DELIVERY_NOTE,
  payload,
});

export const updateDeliveryNoteSuccess = (payload) => ({
  type: UPDATE_DELIVERY_NOTE_SUCCESS,
  payload,
});

export const updateDeliveryNoteFailure = (payload) => ({
  type: UPDATE_DELIVERY_NOTE_FAILURE,
  payload,
});

// Delete delivery note
export const deleteDeliveryNote = (payload) => ({
  type: DELETE_DELIVERY_NOTE,
  payload,
});

export const deleteDeliveryNoteSuccess = (payload) => ({
  type: DELETE_DELIVERY_NOTE_SUCCESS,
  payload,
});

export const deleteDeliveryNoteFailure = (payload) => ({
  type: DELETE_DELIVERY_NOTE_FAILURE,
  payload,
});

// Set delivery note is edit
export const setDeliveryNoteIsEdit = (payload) => ({
  type: SET_DELIVERY_NOTE_IS_EDIT,
  payload,
});
